type PaginationProps = {
  current: number;
  total: number;
  onChange: (page: number) => void;
};

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages = Array.from({ length: total }, (_, index) => index + 1);

  return (
    <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        disabled={current === 1}
        onClick={() => onChange(current - 1)}
        className="flex h-9 items-center gap-1 rounded-md border border-background-300 px-3 text-sm text-foreground-700 transition enabled:hover:border-primary-400 enabled:hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 cursor-pointer"
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>
      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          className={`h-9 w-9 rounded-md text-sm transition cursor-pointer ${
            page === current
              ? 'bg-primary-500 font-medium text-background-50'
              : 'border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600'
          }`}
        >
          {page}
        </button>
      ))}
      <button
        type="button"
        disabled={current === total}
        onClick={() => onChange(current + 1)}
        className="flex h-9 items-center gap-1 rounded-md border border-background-300 px-3 text-sm text-foreground-700 transition enabled:hover:border-primary-400 enabled:hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 cursor-pointer"
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </div>
  );
}